import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import LzSApp from '@lz-app/App';
import LzXFullPagePublicForm from '@lz-layouts/FullPagePublicForm';

export interface LzPPageForgotPassword {
  className?: string;
  style?: React.CSSProperties;
  bgImg?: string;
}

const LzXPageForgotPassword = (props: LzPPageForgotPassword) => {
  const [username, setUsername] = useState('');

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event: React.FormEvent<HTMLFormElement>) => {
    // TODO: Write api code
  };

  return (
    <LzXFullPagePublicForm
      heading="Forgot Password?"
      onSubmit={onSubmit}
      bgImg={props.bgImg || LzSApp.forgot_pwd_bg_image}
      className={props.className}
      style={props.style}
    >

      <FormGroup row>
        <TextField fullWidth variant='outlined' label='Email as Username'
          value={username} onChange={(event) => setUsername(event.target.value)} />
      </FormGroup>

      <FormGroup row sx={{ justifyContent: 'flex-end' }}>
        <Button type='submit' variant='contained' color='primary'>Submit</Button>
      </FormGroup>

      <FormGroup>
        <Grid container>
          <Grid size={{ xs: 6 }}>
            <Link to={'/login'}>
              <KeyboardBackspaceIcon fontSize='small' sx={{ verticalAlign: 'bottom' }} />{' '}Back to Login</Link>
          </Grid>
          <Grid size={{ xs: 6 }} style={{ textAlign: 'right' }}>
            <Link to={'/reset-password'}>Already got code?</Link>
          </Grid>
        </Grid>
      </FormGroup>

    </LzXFullPagePublicForm>
  );
};

export default LzXPageForgotPassword;
